<ng-container *transloco="let t">
  @if (minified) {
    <ng-container class="row">
      @if (activeSearchResult$ | async; as activeSearchResult) {
        <div class="col-12">
          <lib-search-result-item
            [company]="activeSearchResult"
            [minified]="minified"
            [isFinancierSearch]="isFinancierSearch"
            [alreadySelectedFinanciers]="alreadySelectedFinanciers"
            [alreadySelectedWorksites]="alreadySelectedWorksites"
            (selectWorksite)="onSelectWorksite($event)"
            (createWorksite)="onCreateWorksite($event)"
            (extendWorksites)="extendWorksites($event)"
          >
          </lib-search-result-item>
        </div>
      }
    </ng-container>
  }

  @if (!minified) {
    <div class="alert alert-secondary mt-3" role="alert">
      @if (totalHits > 100) {
        <p class="m-0">
          {{ t('worksite_search_total_hits', { totalHits: totalHits }) }}.
          {{ t('worksite_search_hits_max') }}.
          {{ t('worksite_search_refine') }}.
        </p>
      }
      @if ((totalHits <= 100 && totalHits > 10) || totalHits < 1) {
        <p class="m-0">
          {{ t('worksite_search_total_hits', { totalHits: totalHits }) }}.
          {{ t('worksite_search_refine') }}.
        </p>
      }
      @if (totalHits <= 10 && totalHits > 1) {
        <p class="m-0">
          {{ t('worksite_search_total_hits', { totalHits: totalHits }) }}.
        </p>
      }
      @if (totalHits === 1) {
        <p class="m-0">{{ t('worksite_search_one_hit') }}.</p>
      }
    </div>
    @if (result && result.length > 0) {
      <div class="row">
        <span class="ms-auto w-unset mb-1">
          <button vinnova-button-text (click)="expandAll()" type="button">
            <small>{{ t('worksite_search_expand_all') }} + </small>
          </button>
        </span>
        <span class="w-unset">
          <button vinnova-button-text (click)="minimizeAll()" type="button">
            <small>{{ t('worksite_search_minimize_all') }} - </small>
          </button>
        </span>
        <div class="col-12">
          <div class="row p-2 m-0 result-list">
            <div class="col-5 ps-2">
              <strong>{{ t('worksite_name') }}</strong>
            </div>
            <div class="col-3 ps-2">
              <strong>{{ t('worksite_address') }}</strong>
            </div>
            <div class="col-2 ps-2 d-flex justify-content-center">
              <strong>{{ t('worksite_country') }}</strong>
            </div>
            <div class="col-2 ps-2"></div>
          </div>
          @for (company of result; track company) {
            <lib-search-result-item
              [company]="company"
              [countries]="countries"
              [minified]="minified"
              [isFinancierSearch]="isFinancierSearch"
              [alreadySelectedWorksites]="alreadySelectedWorksites"
              [alreadySelectedFinanciers]="alreadySelectedFinanciers"
              (selectWorksite)="onSelectWorksite($event)"
              (createWorksite)="onCreateWorksite($event)"
              (extendWorksites)="extendWorksites($event)"
            >
            </lib-search-result-item>
          }
        </div>
      </div>
    }
    @if (result) {
      <div class="alert alert-secondary mt-3" role="alert">
        <div class="d-flex justify-content-between align-items-center">
          <p class="m-0">{{ t('worksite_company_not_found') }}</p>
          <button
            vinnova-button-text
            (click)="onCreateCompanyAndWorksite()"
            type="button"
          >
            <small>{{ t('worksite_btn_add_new_organisation') }}</small>
          </button>
        </div>
      </div>
    }
  }
</ng-container>
